import { useEffect } from 'react'
import { keepPreviousData, useQuery, useQueryClient } from '@tanstack/react-query'
import type { PlatformDashboardGrowthPeriod } from '@brushfire/types'
import { queryKeys } from '@/api/query-keys'
import { fetchPeopleAccountsDashboard } from './platform-dashboard.api'

/** BR — People & Accounts dashboard polls live metrics every 30s. */
export const PLATFORM_DASHBOARD_POLL_MS = 30_000

const GROWTH_PERIODS: PlatformDashboardGrowthPeriod[] = ['week', 'month']

export function peopleAccountsDashboardQueryOptions(growthPeriod: PlatformDashboardGrowthPeriod) {
  return {
    queryKey: queryKeys.platformDashboard.peopleAccounts(growthPeriod),
    queryFn: () => fetchPeopleAccountsDashboard(growthPeriod),
    staleTime: PLATFORM_DASHBOARD_POLL_MS,
    refetchInterval: PLATFORM_DASHBOARD_POLL_MS,
  } as const
}

/** Warm both week/month caches so toggling does not blank the page. */
export function usePrefetchPlatformPeopleAccountsDashboard() {
  const queryClient = useQueryClient()

  useEffect(() => {
    for (const period of GROWTH_PERIODS) {
      void queryClient.prefetchQuery(peopleAccountsDashboardQueryOptions(period))
    }
  }, [queryClient])
}

export function usePlatformPeopleAccountsDashboard(growthPeriod: PlatformDashboardGrowthPeriod) {
  return useQuery({
    ...peopleAccountsDashboardQueryOptions(growthPeriod),
    placeholderData: keepPreviousData,
  })
}
